// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FnKv","index":"styles_index__Rd7ht"};